module.exports = __webpack_public_path__ + "static/img/land.service.sample2.f77823c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/old-services/land.service.sample2.png
// module id = Q13k
// module chunks = 1